export default {
  WAITING: 'WAITING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  LOCKED: 'LOCKED',
  REVOKED: 'REVOKED',
};
